import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dea7vcjq7: FaireProductEntity = {
  token: "p_6dea7vcjq7",
  type: "product",
  name: "24PCS - Peach Shaped Long Lasting Moisture Lip Balm",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/7994a6b13c9905d5408252efd4fbd3e90ff0fbba345965106d5f4f53e117211c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c53501fc6a2992161234ac617f4a2503440603a6d33493c9fc8b1304b6cee4f1.jpeg",
    "https://cdn.faire.com/fastly/63a899978fd92b9e1fbe1160bdadbd4bfdf2c185ebfd8085f47bc829655820c1.jpeg",
    "https://cdn.faire.com/fastly/d85c9f07583ebf8d061ba639eb3bbf6b103e247fa46e77679355f641dbbf52a6.jpeg",
    "https://cdn.faire.com/fastly/563b04dcb02dc67af535dec28cd23515b7b868de17444c9a6666bd0ca11b1025.jpeg",
  ],
  priceDollars: 0.73,
  description:
    "Size : 12g\r\nKeep lips soft and smooth with this adorable peach-shaped lip balm. Designed for long-term moisturizing and nourishing care, it’s perfect for daily use or as a charming gift. A fun and practical addition to any beauty routine that hydrates while looking irresistibly cute.\n",
  tags: [],
  msrpDollars: 1.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:26.436Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
